module.exports = __webpack_public_path__ + "static/media/logo.3beb2dc1.svg";